module.exports = __webpack_public_path__ + "static/media/fc1.82700f1a.gif";